import useField, { useFieldProps } from "./useField";

const useInput = <T>(props: useFieldProps<T>) => {
  const field = useField(props);
  return {
    ...field,
    fieldType: 'input',
  };
};

export default useInput;
